/* eslint-disable import/prefer-default-export */
import { atom } from 'jotai';

export const showStoreModeNotificationHeaderAtom = atom(false);
